var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "topbar" }, [
        _c("i", { on: { click: _vm.goHome } }),
        _vm._v(" "),
        _c("div", { staticClass: "mainBox1" }, [
          _c(
            "div",
            {
              staticClass: "changeLangBtn",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.moreLang()
                }
              }
            },
            [
              _vm._v("\n        " + _vm._s(_vm.$t("language")) + "\n        "),
              _c("em", { staticClass: "iconfont icon-een" }),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.changeLangBox,
                      expression: "changeLangBox"
                    }
                  ],
                  staticClass: "chooseLangUl"
                },
                _vm._l(_vm.langList, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "chooseLangUlli",
                      on: {
                        click: function($event) {
                          _vm.setLanguage(item.id)
                        }
                      }
                    },
                    [_vm._v(_vm._s(item.name))]
                  )
                })
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "settingBtn",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.setting()
                }
              }
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("myaccount_title")) + "\n        "
              ),
              _c("em", { staticClass: "iconfont icon-een" }),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.settingBoxVis,
                      expression: "settingBoxVis"
                    }
                  ],
                  staticClass: "chooseLangUl chooseLangUls"
                },
                [
                  _c("li", { on: { click: _vm.toMyAccount } }, [
                    _vm._v(_vm._s(_vm.$t("myHome")))
                  ]),
                  _vm._v(" "),
                  _c("li", { on: { click: _vm.race } }, [
                    _vm._v(_vm._s(_vm.$t("myPageTitle")))
                  ]),
                  _vm._v(" "),
                  _c("li", { on: { click: _vm.logOut } }, [
                    _vm._v(_vm._s(_vm.$t("setting_2")))
                  ])
                ]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "banner" }, [
        _c("div", { staticClass: "forget" }, [
          _c("div", { staticClass: "forgetPsd" }, [
            _vm._v(_vm._s(_vm.$t("invite_title")))
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      ]),
      _vm._v(" "),
      _c("LeapPopup", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.maskBox,
            expression: "maskBox"
          }
        ],
        attrs: {
          title: _vm.$t("timeout01"),
          content: _vm.$t("timeout02"),
          cancelButtonTxt: _vm.$t("timeout04"),
          okButtonTxt: _vm.$t("timeout03"),
          isConfirm: false
        },
        on: { onOK: _vm.logOut }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "leftContainer" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/icode_invite_introduce.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-86d366ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86d366ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/invite.vue
// module id = null
// module chunks = 